import { render } from "./QuizDrawerTermsPanel.vue?vue&type=template&id=9daf4c56&scoped=true"
import script from "./QuizDrawerTermsPanel.vue?vue&type=script&lang=js"
export * from "./QuizDrawerTermsPanel.vue?vue&type=script&lang=js"

import "./QuizDrawerTermsPanel.vue?vue&type=style&index=0&id=9daf4c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9daf4c56"]])

export default __exports__